import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {
 
  constructor() { }
  // passing data from sinup logindetails to verify otp page
  public sendUserBasicData = new BehaviorSubject('null');
  setSignupLoginDetails(data):any {
    this.sendUserBasicData.next(data);
  }
  getSignupLoginDetails(){
    return this.sendUserBasicData.asObservable();
  }
  public sendOtpVerifiedData = new BehaviorSubject('null');
  setSignupOtpVerifiedInfo(data):any{
    this.sendOtpVerifiedData.next(data);
  }
  getSignupOtpverifiedInfo(){
    return this.sendOtpVerifiedData.asObservable();
  }
}